import { render } from "./LieferantAddAccountDialog.vue?vue&type=template&id=3d714a64&ts=true"
import script from "./LieferantAddAccountDialog.vue?vue&type=script&lang=ts"
export * from "./LieferantAddAccountDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__